import { ReactNode, useEffect } from 'react';
import { Tabs } from '@mantine/core';
import { useSearchParams } from '../../../../hooks';

type Props = {
  children: ReactNode;
  defaultValue: string;
};

export const SidebarTabs = ({ children, defaultValue }: Props) => {
  const { getSearchParam, changeSearchParam, deleteSearchParam } =
    useSearchParams(['sidebar']);
  const currentValue = getSearchParam('sidebar');

  useEffect(() => {
    changeSearchParam('sidebar', currentValue || defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tabs
      variant="default"
      value={currentValue}
      onTabChange={value =>
        value
          ? changeSearchParam('sidebar', value)
          : deleteSearchParam('sidebar')
      }
    >
      {children}
    </Tabs>
  );
};
